module.exports = __webpack_public_path__ + "static/media/choices.6645369e.svg";